export default function (hash: string, name?: string) {
  const config = useRuntimeConfig()
  return `https://${config.public.rokkaHost}/dynamic/noop/${hash}/${encodeURIComponent(
    name || 'image',
  )}.jpg`
}
